import useDeepCompareEffect from 'use-deep-compare-effect';

import ProtectionServiceEnum from 'redpoints-model-js-common/enumeration/ProtectionServiceEnum';

import { withContext } from 'redpoints-front-common-rp10/components';
import type { WithContextProps } from 'redpoints-front-common-rp10/components/LayoutMainContext/HOCs/withContext';
import { DatabaseNavigationTabsEnum } from 'redpoints-front-common-rp10/enumerations';
import {
  hasProtectionService,
  redirect,
  routeBuilder,
} from 'redpoints-front-common-rp10/helpers';
import { useConfiguration } from 'redpoints-front-common-rp10/hooks';

import { ROUTE_PATHS } from '../config/constants';

type RevenueRecoveryProps = Pick<
  WithContextProps,
  'context' | 'getProtectionServicesOfCurrentContract'
>;

const RevenueRecovery = ({
  context,
  getProtectionServicesOfCurrentContract,
}: RevenueRecoveryProps): null => {
  const { portalServices } = useConfiguration();

  useDeepCompareEffect(() => {
    if (portalServices) {
      if (
        hasProtectionService(
          ProtectionServiceEnum.TESTPURCHASE,
          getProtectionServicesOfCurrentContract()
        )
      ) {
        const databaseRoute = ROUTE_PATHS.DATABASE;
        const activeTab = DatabaseNavigationTabsEnum.TEST_PURCHASE.name;
        const urlRoute = routeBuilder(
          context,
          `${databaseRoute}?activeTab=${activeTab}`
        );
        redirect({ urlRoute });
      } else {
        const url = portalServices.TEST_PURCHASE.marketingUrl;
        window.open(url, '_blank');
        window.history.back();
      }
    }
  }, [context, portalServices, getProtectionServicesOfCurrentContract]);

  return null;
};

export default withContext(RevenueRecovery);
